// Eén lichte adreslijst voor de serverroutes en de filmkop in de Navbar.
// Geen hotelregister of server-only imports in de kopbalkbundel.
export const LUXE_BELEVING_ADRESSEN = Object.freeze({
  "wintersport": "wintersport",
  "ver_weg": "ver-weg",
  "citybreak": "citybreaks",
  "zon_en_zee": "zon-en-zee",
  "alles_verzorgd": "alles-verzorgd",
  "landgoed": "landgoed-en-natuur",
  "wellness": "wellness",
  "kastelen": "kastelen",
  "binnen_rijafstand": "binnen-rijafstand",
  "bergen_zomer": "bergen-in-de-zomer"
});
